import { useEffect, useRef } from 'react';
import * as signalR from '@microsoft/signalr';
import { AvailabilityUpdatedMessage } from 'types/availability';

type AvailabilityCallback = (msg: AvailabilityUpdatedMessage) => void;

export function useAvailabilitySignalr(onAvailabilityUpdated: AvailabilityCallback) {
  const connectionRef = useRef<signalR.HubConnection | null>(null);

  useEffect(() => {
    const connection = new signalR.HubConnectionBuilder()
      .withUrl(`${process.env.REACT_APP_HIPAA_LINK_API_URI}availability`)
      .withAutomaticReconnect()
      .build();

    // 🔔 Live updates
    connection.on('AvailabilityUpdated', (message: AvailabilityUpdatedMessage) => {
      onAvailabilityUpdated(message);
    });

    // 🧠 Initial snapshot (THIS was missing)
    connection.on('AvailabilitySnapshot', (snapshot: AvailabilityUpdatedMessage[]) => {
      snapshot.forEach(onAvailabilityUpdated);
    });

    connection
      .start()
      .then(() => {
        console.log('[AvailabilityHub] connected');
        // no invoke — server sends snapshot in OnConnectedAsync
      })
      .catch((err) => {
        console.error('[AvailabilityHub] connection failed', err);
      });

    connectionRef.current = connection;

    return () => {
      connection.off('AvailabilityUpdated');
      connection.off('AvailabilitySnapshot');
      connection.stop();
    };
  }, [onAvailabilityUpdated]);
}
